module.exports = __webpack_public_path__ + "static/media/semantic-segmentation.json.a51c4372.resp";